import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot} from '@angular/router';
import {UtilitiesService} from "../_services/utilities.service";
import {UserService} from "../_services/user.service";
import {Angulartics2GoogleTagManager} from "angulartics2/gtm";
import {AuthService} from "../_services/auth.service";

@Injectable()
export class GoogleAnalyticsGuard implements CanActivate {

    constructor(private router: Router,
                private userService: UserService,
                private authService: AuthService,
                private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
                private utilitiesService: UtilitiesService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const urlParams: Params = route.queryParams;
        let params: any = {...urlParams}; // so we can use the "delete" property

        this.angulartics2GoogleTagManager.pushLayer(params);

        // strip email from the params and refresh
        if (params.hasOwnProperty('email')) {
            this.utilitiesService.setLocal("email", params["email"]);
            let url = state.url.replace(new RegExp( '([?&])email(=[^&]*)?&?', 'gi'), '$1');
            this.router.navigateByUrl(url);
            return false;
        }

        // if they are logged in, ignore user params on the url
        if (!this.authService.loggedIn()) {
            let userData = this.userService.getCurrentUserData();

            if (params.hasOwnProperty('referralsource')) {
                if (UtilitiesService.isEmpty(userData.referral_source)) {
                    userData.referralSource = params.referralsource;
                }
                this.utilitiesService.setLocal("referral_source", params.referralsource);
                delete params.referralsource;
            }
            if (params.hasOwnProperty('firstname')) {
                if (UtilitiesService.isEmpty(userData.firstname)) {
                    userData.firstName = params.firstname;
                }
                delete params.firstname;
            }
            if (params.hasOwnProperty('lastname')) {
                if (UtilitiesService.isEmpty(userData.lastname)) {
                    userData.lastName = params.lastname;
                }
                delete params.lastName;
            }
            if (params.hasOwnProperty('zip')) {
                if (UtilitiesService.isEmpty(userData.zip)) {
                    userData.zip = params.zip;
                }
                delete params.zip;
            }
            if (params.hasOwnProperty('zipcity')) {
                if (UtilitiesService.isEmpty(userData.zip)) {
                    userData.zip = params.zipcity;
                }
                delete params.zipcity;
            }
            if (params.hasOwnProperty('phone')) {
                if (UtilitiesService.isEmpty(userData.phone)) {
                    userData.phone = params.phone;
                }
                delete params.phone;
            }
            if (params.hasOwnProperty('email')) {
                if (UtilitiesService.isEmpty(userData.email)) {
                    userData.email = params.email;
                }
                delete params.email;
            }

            // this is a little risky because it isn't saved in local storage
            this.userService.updateUserData(userData);
        }

        let vehicle: any = {};
        if (params.hasOwnProperty('vin')) {
            vehicle.vin = params['vin'];
            delete params.vin;
        }
        if (params.hasOwnProperty('year')) {
            vehicle.year = params['year'];
            delete params.year;
        }
        if (params.hasOwnProperty('make')) {
            vehicle.make = params['make'];
            delete params.make;
        }
        if (params.hasOwnProperty('model')) {
            vehicle.model = params['model'];
            delete params.model;
        }
        if (params.hasOwnProperty('trim')) {
            vehicle.trim = params['trim'];
            delete params.trim;
        }
        if (params.hasOwnProperty('engine')) {
            vehicle.engine = params['engine'];
            delete params.engine;
        }
        if (params.hasOwnProperty('transmission')) {
            vehicle.transmission = params['transmission'];
            delete params.transmission;
        }
        if (params.hasOwnProperty('drivetrain')) {
            vehicle.drivetrain = params['drivetrain'];
            delete params.drivetrain;
        }
        this.utilitiesService.setLocal('urlVehicle', JSON.stringify(vehicle));

        // source overrules utm_source
        if (params.hasOwnProperty('source')) {
            this.utilitiesService.setLocal("utm_source", params['source']);
            delete params.source;
        } else if (params.hasOwnProperty('utm_source')) {
            this.utilitiesService.setLocal("utm_source", params['utm_source']);
            delete params.utm_source;
        }

        if (params.hasOwnProperty('utm_medium')) {
            this.utilitiesService.setLocal("utm_medium", params['utm_medium']);
            delete params.utm_medium;
        }

        if (params.hasOwnProperty('utm_term')) {
            this.utilitiesService.setLocal("utm_term", params['utm_term']);
            delete params.utm_term;
        }

        if (params.hasOwnProperty('campaign')) {
            this.utilitiesService.setLocal("utm_campaign", params['campaign']);
            delete params.campaign;
        } else if (params.hasOwnProperty('utm_campaign')) {
            this.utilitiesService.setLocal("utm_campaign", params['utm_campaign']);
            delete params.utm_campaign;

        }

        if (params.hasOwnProperty('utm_content')) {
            this.utilitiesService.setLocal("utm_content", params['utm_content']);
            delete params.utm_content;
        }

        if (params.hasOwnProperty('keyword')) {
            this.utilitiesService.setLocal("utm_term", params['keyword']);
            delete params.keyword;
        }

        if (params.hasOwnProperty('gclid')) {
            this.utilitiesService.setLocal("gclid", params['gclid']);
            delete params.gclid;
        }

        if (params.hasOwnProperty('fbclid')) {
            this.utilitiesService.setLocal("fbclid", params['fbclid']);
            delete params.fbclid;
        }

        if (params.hasOwnProperty('market')) {
            this.userService.setMarket(params['market']);
            delete params.market;
        }

        if (params.hasOwnProperty('adgroup')) {
            this.utilitiesService.setLocal("adgroup", params['adgroup']);
            delete params.adgroup;
        }

        if (params.hasOwnProperty('adposition')) {
            this.utilitiesService.setLocal("adposition", params['adposition']);
            delete params.adposition;
        }

        if (params.hasOwnProperty('network')) {
            this.utilitiesService.setLocal("network", params['network']);
            delete params.network;
        }

        if (params.hasOwnProperty('matchtype')) {
            this.utilitiesService.setLocal("matchtype", params['matchtype']);
            delete params.matchtype;
        }

        if (params.hasOwnProperty('device')) {
            this.utilitiesService.setLocal("device", params['device']);
            delete params.device;
        }

        if (params.hasOwnProperty('creative')) {
            this.utilitiesService.setLocal("creative", params['creative']);
            delete params.creative;
        }

        if (params.hasOwnProperty('partner')) {
            this.utilitiesService.setLocal("partner", params['partner']);
            delete params.partner;
        }

        // if it's not a param we recognize, put it in "extra params"
        // make sure params are only alpha numeric characters
        for (let param in params) {
            if (params.hasOwnProperty(param)) {
                const cleanedKey = param.replace(/[\W_]+/g, '');
                const cleanedValue = params[param].replace(/[\W_]+/g, '');
                delete params[param];
                params[cleanedKey] = cleanedValue;
            }
        }
        try {
            this.utilitiesService.setLocal("extraParams", JSON.stringify(params));
        } catch (e) {
            UtilitiesService.consoleLog(e);
        }

        if (params.hasOwnProperty('service') && UtilitiesService.isEmpty(route.url)) {
            this.utilitiesService.setLocal("service", params['service']);
            let navigationExtras = {
                queryParams: params,
                replaceUrl: true
            };
            switch (params['service']) {
                case "10":
                    this.router.navigate(['/services/diagnostic'], navigationExtras);
                    return false;
                case "1":
                    this.router.navigate(['/services/brake-pad-replacement'], navigationExtras);
                    return false;
                case "7":
                    this.router.navigate(['/services/oil-change'], navigationExtras);
                    return false;
                case "9":
                    this.router.navigate(['/services/water-pump-replacement'], navigationExtras);
                    return false;
                case "8":
                    this.router.navigate(['/services/alternator-replacement'], navigationExtras);
                    return false;
                case "19":
                    this.router.navigate(['/services/valve-cover-gasket-replacement'], navigationExtras);
                    return false;
                case "14":
                    this.router.navigate(['/services/starter-replacement'], navigationExtras);
                    return false;
                case "16":
                    this.router.navigate(['/services/ac-recharge'], navigationExtras);
                    return false;
                case "15":
                    this.router.navigate(['/services/battery-replacement'], navigationExtras);
                    return false;
                case "4":
                    this.router.navigate(['/services/no-start'], navigationExtras);
                    return false;
                case "2":
                    this.router.navigate(['/mobile-mechanic'], navigationExtras);
                    return true;
                case "3":
                    this.router.navigate(['/fleet-management'], navigationExtras);
                    return false;
                default:
                    break;
            }
        }

        return true;

    } // canActivate()
} // GoogleAnalyticsGuard
